exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-footer {\n  margin-top: 70px; }\n\n.page-view.container {\n  margin-top: 32px; }\n  .page-view.container .left-cont {\n    border-right: 1px solid #dadedd;\n    padding: 0 40px 60px;\n    min-height: 1100px; }\n    .page-view.container .left-cont .position {\n      font-size: 18px;\n      color: #222222;\n      line-height: 54px; }\n\n/* Small Devices, Mobile */\n@media only screen and (max-width: 767px) {\n  .page-view.container {\n    margin-top: 0; }\n    .page-view.container .left-cont {\n      border-right: none;\n      padding: 0 12px 40px;\n      min-height: 0; }\n      .page-view.container .left-cont .position {\n        display: none;\n        padding: 10px 0;\n        margin: 0; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/app/components/page/page.scss
// module id = 1007
// module chunks = 3